// Frontend API configuration.
//
// This file used to ship a large `ENDPOINTS` map (e.g. `/api/signin`, `/api/getProducts`)
// that did NOT match the real backend routes (which live under `/api/v1/...`) — it was
// only ever consumed by `utils/apiUtils.js`, which was deleted as dead code in Phase 3.1.
// The block was removed alongside `getApiEndpoints()` and the unused `ENVIRONMENT_CONFIG`
// scaffolding so there is now ONE place for endpoint URLs: `src/common/index.js`.

const API_CONFIG = {
  // Backend API Base URL — env-var first, then sensible default per environment.
  BASE_URL: process.env.REACT_APP_API_BASE_URL || (
    process.env.NODE_ENV === 'production'
      ? 'https://www.urbanai.co.zw'
      : 'http://localhost:8080'
  ),

  // Default request timeout (ms). Used by callers that need an explicit number.
  TIMEOUT: 30000,
}

// Helper for callers that want to compose URLs from a relative path.
// Used today by store/locationSlice.js. New code should prefer importing endpoint URLs
// directly from `src/common/index.js` (the single source of truth for endpoint paths).
export const buildApiUrl = (endpoint) => `${API_CONFIG.BASE_URL}${endpoint}`

export default API_CONFIG
